import React from 'react';
import { FilePdf, FileArrowDown } from '@phosphor-icons/react';
import { getFileUrl } from '../services/api';

/**
 * Renders a chat message attachment (image inline preview or PDF/file link).
 * Props:
 *   attachment: { file_id, filename, content_type, size }
 *   mine: bool (controls colors)
 */
const ChatAttachment = ({ attachment, mine }) => {
  if (!attachment) return null;
  const ct = (attachment.content_type || '').toLowerCase();
  const url = getFileUrl(attachment.file_id);
  const isImage = ct.startsWith('image/');
  const isPdf = ct === 'application/pdf';

  if (isImage) {
    return (
      <a href={url} target="_blank" rel="noopener noreferrer" className="block mt-1">
        <img
          src={url}
          alt={attachment.filename}
          className="rounded max-h-72 max-w-full object-contain border border-border/40 bg-white"
          loading="lazy"
        />
      </a>
    );
  }

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className={`mt-1 flex items-center gap-2 px-2.5 py-2 rounded border ${
        mine ? 'bg-white/15 border-white/30 hover:bg-white/25' : 'bg-secondary/50 border-border hover:bg-secondary'
      }`}
      data-testid={`chat-attachment-${attachment.file_id}`}
    >
      {isPdf ? <FilePdf weight="duotone" className="w-7 h-7 shrink-0" /> : <FileArrowDown weight="duotone" className="w-7 h-7 shrink-0" />}
      <div className="min-w-0 flex-1">
        <p className="text-xs font-medium truncate">{attachment.filename}</p>
        <p className="text-[10px] opacity-70">{Math.round((attachment.size || 0) / 1024)} KB · open</p>
      </div>
    </a>
  );
};

export default ChatAttachment;
